import React, { useCallback, useState } from 'react';
import { Col } from 'react-bootstrap';
import { useProduto } from '~/pages/Produto/hooks/useProduto';
import { ClearButton, ConfirmButton } from '~/components/Buttons';
import { moneyFormat } from '~/utils/functions';
import { BuscaProduto, InputSelect } from '~/components/NovosInputs';
import { toast } from 'react-toastify';
import { nanoid } from 'nanoid';
import { insertOrUpdate } from '~/utils/masterDetail';
import { SelectType } from '~/components/NovosInputs/InputSelect/protocols';
import { useProdutoQueries } from '../../../hooks/useQueriesProduto';

export const FormDerivados: React.FC = () => {
  const [produtoDerivado, setProdutoDerivado] = useState<any>({});
  const {
    formProduto,
    register,
    control,
    formState: { errors },
    setValue,
    clearErrors,
    getValues,
    setError,
    lojas,
    setLoadingTableDerivado,
    isEditingDerivado,
    rowsDerivado,
    setRowsDerivado,
    masterDetail,
    setMasterDetail,
    handleSetFocus,
  } = useProduto();

  const { tiposDeAjuste } = useProdutoQueries();

  const handleClearDerivado = useCallback(() => {
    setProdutoDerivado({});
    clearErrors('produto_derivado');
    clearErrors('cod_tipo_ajuste');
    setTimeout(() => {
      setValue('produto_derivado', { value: undefined, label: '' });
      setValue('cod_tipo_ajuste', undefined);
    }, 100);
    const input = document.getElementById(
      'tipoAjusteDerivado',
    ) as HTMLInputElement;
    if (input) {
      input.value = '';
      input.textContent = '';
      input.placeholder = '';
    }
  }, [setValue, clearErrors]);

  const validateDerivado = useCallback(
    (produto: any, ajuste: SelectType): boolean => {
      let hasError = false;
      if (!produto || !produto.cod_produto) {
        setError('produto_derivado', { type: 'required' });
        hasError = true;
      }
      if (!ajuste || !ajuste.value) {
        setError('cod_tipo_ajuste', { type: 'required' });
        hasError = true;
      }
      return hasError;
    },
    [setError],
  );

  const handleAddProdutoDerivado = useCallback(async () => {
    const { cod_tipo_ajuste } = getValues();
    const { cod_produto, des_produto, cod_departamento, des_unidade_venda } =
      produtoDerivado;

    if (validateDerivado(produtoDerivado, cod_tipo_ajuste)) return;

    setLoadingTableDerivado(true);

    const produtoExistente = rowsDerivado.find(
      (i) => i.des_produto === des_produto,
    );

    if (!isEditingDerivado && produtoExistente) {
      toast.warn('Descrição já vinculada');
      setLoadingTableDerivado(false);
      return;
    }

    try {
      const insertValues = {
        uuid: nanoid(),
        cod_produto_derivado: cod_produto,
        des_produto,
        cod_tipo_ajuste,
        cod_departamento: {
          value: cod_departamento,
          label: String(cod_departamento),
        },
        des_unidade: {
          value: des_unidade_venda,
          label: des_unidade_venda,
        },
      };
      const rowsDetail: any[] = await insertOrUpdate(
        'produtos-derivados',
        insertValues,
        masterDetail,
        setMasterDetail,
      );

      setRowsDerivado(rowsDetail);
      handleClearDerivado();
    } catch (error: any) {
      toast.warn(`Erro ao adicionar produto derivado: ${error.message}`);
    } finally {
      setLoadingTableDerivado(false);
    }
  }, [
    produtoDerivado,
    getValues,
    isEditingDerivado,
    masterDetail,
    rowsDerivado,
    setLoadingTableDerivado,
    setMasterDetail,
    setRowsDerivado,
    handleClearDerivado,
    validateDerivado,
  ]);

  return (
    <>
      <Col sm={12} md={5}>
        <BuscaProduto
          label="Produto Derivado *"
          placeholder="Informe pelo menos 3 caracteres do Código, Descrição ou GTIN"
          name="produto_derivado"
          buscaNasLojas={lojas}
          customOptions={{
            showSelecionarItensContendo: false,
            hideBuscarPor: true,
            buscaPadrao: 'Produto',
            buscarPor: ['Produto'],
          }}
          control={control}
          register={register}
          isError={!!errors.produto_derivado}
          listWidth="720px"
          getProduct={(selected: any) => {
            if (formProduto.cod_produto.value === selected[0].cod_produto) {
              handleClearDerivado();
              return toast.warn(
                'Produto derivado não pode ser o mesmo que o produto pai',
              );
            }
            const precoFormatted = !selected[0]?.val_preco
              ? '0,00'
              : moneyFormat(selected[0]?.val_preco?.toString(), 2, 2);
            setProdutoDerivado(selected[0]);
            setValue('produto_derivado', {
              value: selected[0].cod_produto,
              label: `${selected[0].cod_produto} - ${
                selected[0].des_produto
              }| Loja: ${selected[0]?.cod_loja?.toString()} | Venda: ${precoFormatted} | Estq.: ${moneyFormat(
                selected[0]?.qtd_total_estoque?.toString(),
                3,
                3,
              )} |`,
            });
            clearErrors('produto_derivado');
            handleSetFocus('cod_tipo_ajuste');
          }}
          setValue={setValue}
        />
      </Col>
      <Col sm={12} md={3}>
        <InputSelect
          id="tipoAjusteDerivado"
          label="Ajuste Padrão da Produção *"
          placeholder="Selecione o Tipo de Ajuste"
          name="cod_tipo_ajuste"
          register={register}
          isError={!!errors.cod_tipo_ajuste}
          control={control}
          options={tiposDeAjuste.data as SelectType[]}
          changeSelected={(selected: SelectType) => {
            setValue('cod_tipo_ajuste', selected);
            clearErrors('cod_tipo_ajuste');
            setTimeout(() => {
              document.getElementById('subimitBtn')?.focus();
            }, 10);
          }}
        />
      </Col>
      <Col
        sm={12}
        md={4}
        className="d-flex align-items-center align-self-end justify-content-end"
      >
        <ConfirmButton id="subimitBtn" onClick={handleAddProdutoDerivado}>
          Adicionar
        </ConfirmButton>
        <ClearButton onClick={handleClearDerivado}>Limpar</ClearButton>
      </Col>
    </>
  );
};
